import { AppLanguage } from '@core-lib/enums/app-language.enum';
import { INatureAffairePieceJointe } from '@core-lib/models/affaire.model';
import { IAppConfig } from '@core-lib/models/app-config.model';
import { AutocompleteControlData, IAutocompleteData } from '@core-lib/models/autocomplete.model';
import { IReferentials } from '@core-lib/models/referentials.model';
import { IStoreEntityStateSlice, createEntitySlice } from '@core-lib/store/entity-slice.function';
import { ModalRef } from '@core-lib/modules/modal-container';

export interface ISharedStoreState {
	language: AppLanguage;
	config: IStoreEntityStateSlice<IAppConfig>;
	referentials: IStoreEntityStateSlice<IReferentials>;
	autocompleteData: AutocompleteControlData;
	autocompleteAddedTiers: IAutocompleteData[];
	autocompleteControlToReset: string[];
	confirmModal: ModalRef['id'];
	cancelConfirmModal: ModalRef['id'];
	typesDocuments: INatureAffairePieceJointe[];
}

export const initialState: ISharedStoreState = {
	language: AppLanguage.Fr,
	config: createEntitySlice(),
	referentials: createEntitySlice(),
	autocompleteData: null,
	autocompleteAddedTiers: [],
	autocompleteControlToReset: null,
	confirmModal: null,
	cancelConfirmModal: null,
	typesDocuments: []
};
